import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import EasmRelatedFindingsDataProvider from '../dataProvider/EasmRelatedFindingsDataProvider';

export class EasmRelatedFindingsDataProviderFactory extends BaseWebComponentDataProviderFactory {
  public constructor() {
    super();

    this.map.set(API_TYPE_GZ, EasmRelatedFindingsDataProvider);
  }
}
